module.exports = __webpack_public_path__ + "static/media/selectLeftArrow.92d3f25c.svg";